import { Box, Grid, Checkbox, FormControlLabel } from "@mui/material";
import { Tabs } from "antd";
import { useSnackbar } from "notistack";
import { useEffect, useMemo, useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import NunitoText from "../components/general/NunitoText";
import ReusableButton from "../components/general/ReusableButton";
import ReusableSelect from "../components/general/ReusableSelect";
import ReusableTextField from "../components/general/ReusableTextField";
import ReusableCheckbox from "../components/general/ReusableCheckbox";
import { showWarningSwal } from "../functions/alert";
import { getCompetition } from "../functions/getData";
import {
  // uploadTeamMembersCsv,
  submitTeamMembersForTeamCompetition,
  submitNonSimocTeamMembersForTeamCompetition,
} from "../functions/postData";
import { showNotification } from "../functions/snackbar";

export default function ConfigureTeamMembersInTeamCompetitions() {
  let location = useLocation();

  const controller = useMemo(() => new AbortController(), []);
  const signal = controller.signal;
  const [contestName, setName] = useState("");
  const [competition, setCompetition] = useState([]);
  const [isSimoc, setIsSimoc] = useState("false");
  document.title = "Configure Team Members";
  const [round, setRound] = useState();
  const [levelOptions, setLevelOptions] = useState([]);

  // Updated state for multiple teams
  const [teams, setTeams] = useState([
    {
      id: 1,
      division: "",
      teamNumber: "",
      participants: [
        { participant_index: "", is_absent: false },
        { participant_index: "", is_absent: false },
        { participant_index: "", is_absent: false },
        { participant_index: "", is_absent: false },
        { participant_index: "", is_absent: false },
      ],
      isMinimized: false,
    },
  ]);

  const [csvFile, setCSVFile] = useState(null);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    if (location.search.slice(0, 4) === "?id=") {
      getCompetition(
        `/${Number(location.search.slice(4).split("&")[0])}`,
        signal
      ).then((res) => {
        const competition = res;
        setRound(competition.rounds[0].id);
        setName(competition.name);
        setIsSimoc(location.search.split("&")[1].split("=")[1]);
        setCompetition(res);
      });
    }
    return () => {
      controller.abort();
    };
  }, [controller, signal]);

  useEffect(() => {
    if (competition.rounds) {
      let levelOptionss = [];
      competition.rounds.map((round, index) => {
        round.levels.map((el) => {
          let obj = { id: el.id, option: `round${index + 1} ${el.name}` };
          levelOptionss.push(obj);
        });
      });
      setLevelOptions(levelOptionss);
    }
  }, [competition, setName]);

  const tabStyle = `
    .custom-tabs .ant-tabs-tab {
      flex: 1;
      justify-content: center;
      text-align: center;
      color: #5E74C2;
      background-color:rgb(215, 215, 215)  !important;
    }

    .custom-tabs .ant-tabs-nav-list {
      display: flex;
      width: 100%;
    }

    .custom-tabs .ant-tabs-tab-active {
      background-color: #5E74C2 !important;
      border-radius: 12px 12px 0 0;
      font-weight: bold;
    }

    .custom-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #ffffff !important;
  }
  `;

  const downloadSampleCsvTemplate = () => {
    // Create headers array with Is Absent columns after each participant
    const headers = [
      "Division",
      "Team Number",
      "Participant 1",
      "Is Absent",
      "Participant 2",
      "Is Absent",
      "Participant 3",
      "Is Absent",
      "Participant 4",
      "Is Absent",
      "Participant 5",
      "Is Absent",
    ];

    // Create CSV content with headers and 5 empty rows
    const csvContent = [
      headers.join(","),
      ",,,,,,,,,,,,",
      ",,,,,,,,,,,,",
      ",,,,,,,,,,,,",
      ",,,,,,,,,,,,",
      ",,,,,,,,,,,,",
    ].join("\n");

    // Create blob and download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "team-members-template.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleUploadTeamMembersCsv = async () => {
    try {
      if (!csvFile) {
        showWarningSwal("Please select a file first");
        return;
      }
      // Parse CSV file
      const reader = new FileReader();
      reader.onload = async (event) => {
        const csvText = event.target.result;
        const rows = csvText.split("\n").map((row) => row.trim());

        // Skip header row and filter out empty rows
        const dataRows = rows.slice(1).filter((row) => row.length > 0);

        // Parse each row into required format
        // Expected format: Division, Team Number, Participant 1, Is Absent 1, Participant 2, Is Absent 2, ...
        const parsedTeams = dataRows.map((row) => {
          const cells = row.split(",").map((cell) => cell.trim());
          const division = cells[0];
          const teamNumber = cells[1];

          // Parse participants in pairs (participant_index, is_absent)
          const participants = [];
          for (let i = 2; i < cells.length; i += 2) {
            const participantIndex = cells[i];
            const isAbsentStr = (cells[i + 1] || "false")
              .toString()
              .trim()
              .toLowerCase();

            // Only add participant if participant_index is not empty
            if (participantIndex && participantIndex !== "") {
              // Convert string to boolean - handles 0, 1, true, false (case-insensitive)
              // true or 1 means participant is absent
              const isAbsent = isAbsentStr === "true" || isAbsentStr === "1";
              participants.push({
                participant_index: participantIndex,
                is_absent: isAbsent,
              });
            }
          }

          return {
            division,
            teamNumber,
            participants,
          };
        });

        await handleSaveTeamMembers(parsedTeams);
      };

      reader.readAsText(csvFile);

      // const response = await uploadTeamMembersCsv(csvFile);
      showNotification(
        "success",
        "File uploaded successfully",
        enqueueSnackbar,
        closeSnackbar
      );
      // Clear the file after successful upload
      setCSVFile(null);
    } catch (err) {
      console.error("MW upload error:", err);
      showWarningSwal(err.message || "Error uploading file. Please try again.");
    }
  };

  const handleTeamMembersCsvFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (
      selectedFile &&
      [
        "text/csv",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ].includes(selectedFile.type)
    ) {
      setCSVFile(selectedFile);
    } else {
      alert("Only CSV or XLSX files are allowed");
    }
  };

  const handleSaveTeamMembers = async (teams) => {
    try {
      const allTeamsData = teams.map((team) => {
        return {
          division: team.division,
          team_number: team.teamNumber,
          participants: team.participants
            .filter(
              (participant) =>
                participant.participant_index !== "" &&
                participant.participant_index !== undefined
            )
            .map((participant) => ({
              participant_index: participant.participant_index,
              is_absent: participant.is_absent || false,
            })),
        };
      });

      const response =
        isSimoc === "true"
          ? await submitTeamMembersForTeamCompetition(
              allTeamsData,
              competition.id
            )
          : await submitNonSimocTeamMembersForTeamCompetition(
              allTeamsData,
              competition.id
            );

      showNotification(
        "success",
        `Team members saved successfully for ${teams.length} team(s)`,
        enqueueSnackbar,
        closeSnackbar
      );
    } catch (err) {
      console.error("Save team members error:", err);
      showWarningSwal(
        err.message || "Error saving team members. Please try again."
      );
    }
  };

  const addExtraTeam = () => {
    const newTeamId = Math.max(...teams.map((t) => t.id)) + 1;
    setTeams([
      ...teams,
      {
        id: newTeamId,
        division: "",
        teamNumber: "",
        participants: [
          { participant_index: "", is_absent: false },
          { participant_index: "", is_absent: false },
          { participant_index: "", is_absent: false },
          { participant_index: "", is_absent: false },
          { participant_index: "", is_absent: false },
        ],
        isMinimized: false,
      },
    ]);
  };

  const updateTeam = (teamId, field, value) => {
    setTeams(
      teams.map((team) =>
        team.id === teamId ? { ...team, [field]: value } : team
      )
    );
  };

  const updateTeamParticipant = (teamId, participantIndex, value) => {
    setTeams(
      teams.map((team) => {
        if (team.id === teamId) {
          const newParticipants = [...team.participants];
          newParticipants[participantIndex] = {
            ...newParticipants[participantIndex],
            participant_index: value,
          };
          return { ...team, participants: newParticipants };
        }
        return team;
      })
    );
  };

  const updateTeamParticipantAbsent = (teamId, participantIndex, isAbsent) => {
    setTeams(
      teams.map((team) => {
        if (team.id === teamId) {
          const newParticipants = [...team.participants];
          newParticipants[participantIndex] = {
            ...newParticipants[participantIndex],
            is_absent: isAbsent,
          };
          return { ...team, participants: newParticipants };
        }
        return team;
      })
    );
  };

  const toggleTeamMinimize = (teamId) => {
    setTeams(
      teams.map((team) =>
        team.id === teamId ? { ...team, isMinimized: !team.isMinimized } : team
      )
    );
  };

  const removeTeam = (teamId) => {
    if (teams.length > 1) {
      const newTeams = teams.filter((team) => team.id !== teamId);
      console.log("New teams after removal:", newTeams);
      setTeams(newTeams);
    } else {
      console.log("Cannot remove team - only one team left");
    }
  };

  return (
    <Box style={{ flexGrow: 1 }}>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        style={{ paddingInline: 42, marginTop: 30 }}
      >
        <NunitoText
          value={`${contestName} - Configure Team Members`}
          fontSize={40}
          fontWeight={700}
          italic
          color="#144A94"
        />
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          style={{ marginTop: 30, width: "100%" }}
        ></Grid>
        <style>{tabStyle}</style>
        <Tabs
          className="custom-tabs"
          defaultActiveKey="ManualEntry"
          type="card"
          size="large"
          style={{
            marginBottom: 32,
            width: "100%",
            border: "2px solid #5E74C2",
            borderRadius: "8px",
          }}
          items={[
            {
              label: "Manual Entry",
              key: "ManualEntry",
              children: (
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  style={{ padding: 20 }}
                >
                  <Grid container spacing={1} style={{ width: "100%" }}>
                    {teams.map((team, teamIndex) => (
                      <Grid item xs={12} key={team.id}>
                        <div
                          style={{
                            border: "2px solid #144A94",
                            borderRadius: "8px",
                            padding: "20px",
                            marginBottom: "20px",
                            backgroundColor: "#f8f9fa",
                          }}
                        >
                          {/* Team Header with Minimize/Remove buttons */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "15px",
                              paddingBottom: "10px",
                              borderBottom: "1px solid #dee2e6",
                            }}
                          >
                            <NunitoText
                              value={`Team ${team.id}`}
                              fontSize={24}
                              fontWeight={700}
                              color="#144A94"
                            />
                            <div style={{ display: "flex", gap: "10px" }}>
                              <ReusableButton
                                text="Remove"
                                bgColor="#dc3545"
                                fontSize={14}
                                height={35}
                                width={100}
                                onClick={() => removeTeam(team.id)}
                                allowSpam={true}
                              />
                              <button
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  backgroundColor: "#6c757d",
                                  border: "none",
                                  borderRadius: "14px",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#FFF",
                                }}
                                onClick={() => toggleTeamMinimize(team.id)}
                              >
                                {team.isMinimized ? (
                                  <FaChevronDown style={{ fontSize: "20px" }} />
                                ) : (
                                  <FaChevronUp style={{ fontSize: "20px" }} />
                                )}
                              </button>
                            </div>
                          </div>

                          {!team.isMinimized && (
                            <>
                              {/* Division Dropdown */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  width: "100%",
                                  marginBottom: "15px",
                                }}
                              >
                                <div style={{ width: "12%", marginTop: 0 }}>
                                  <NunitoText
                                    value="Division"
                                    fontSize={20}
                                    fontWeight={600}
                                    align="left"
                                  />
                                </div>
                                <div
                                  style={{
                                    width: "4%",
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: 2,
                                      height: 20,
                                      backgroundColor: "#000",
                                    }}
                                  />
                                </div>
                                <div style={{ width: "84%", marginTop: 0 }}>
                                  <ReusableSelect
                                    type="filter"
                                    width={250}
                                    bgColor="#F2F2F2"
                                    borderColor="#707070"
                                    label="Division"
                                    state={team.division}
                                    setState={(value) =>
                                      updateTeam(team.id, "division", value)
                                    }
                                    options={[
                                      {
                                        value: "UP",
                                        option: "Upper Primary Division",
                                      },
                                      {
                                        value: "LP",
                                        option: "Lower Primary Division",
                                      },
                                      {
                                        value: "LS",
                                        option: "Lower Secondary Division",
                                      },
                                      {
                                        value: "US",
                                        option: "Upper Secondary Division",
                                      },
                                    ]}
                                  />
                                </div>
                              </div>

                              {/* Team Number Input */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  width: "100%",
                                  marginBottom: "15px",
                                }}
                              >
                                <div style={{ width: "12%", marginTop: 0 }}>
                                  <NunitoText
                                    value="Team Number"
                                    fontSize={20}
                                    fontWeight={600}
                                    align="left"
                                  />
                                </div>
                                <div
                                  style={{
                                    width: "4%",
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: 2,
                                      height: 20,
                                      backgroundColor: "#000",
                                    }}
                                  />
                                </div>
                                <div style={{ width: "84%", marginTop: 0 }}>
                                  <ReusableTextField
                                    type="default"
                                    width={250}
                                    bgColor="#F2F2F2"
                                    borderColor="#707070"
                                    placeholder="Enter team number"
                                    state={team.teamNumber}
                                    setState={(value) =>
                                      updateTeam(team.id, "teamNumber", value)
                                    }
                                  />
                                </div>
                              </div>

                              {/* Participants Section */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  width: "100%",
                                  marginBottom: "15px",
                                }}
                              >
                                <div style={{ width: "12%", marginTop: 0 }}>
                                  <NunitoText
                                    value="Participants"
                                    fontSize={20}
                                    fontWeight={600}
                                    align="left"
                                  />
                                </div>
                                <div
                                  style={{
                                    width: "4%",
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: 2,
                                      height: 20,
                                      backgroundColor: "#000",
                                    }}
                                  />
                                </div>

                                <div
                                  style={{
                                    width: "84%",
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: "16px",
                                    alignItems: "flex-start",
                                    flexWrap: "wrap",
                                  }}
                                >
                                  {team.participants.map(
                                    (participant, index) => (
                                      <div
                                        key={index}
                                        style={{
                                          minWidth: "200px",
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "8px",
                                        }}
                                      >
                                        <ReusableTextField
                                          type="default"
                                          width={250}
                                          bgColor="#F2F2F2"
                                          borderColor="#707070"
                                          placeholder={`Participant ${
                                            index + 1
                                          }`}
                                          state={participant.participant_index}
                                          setState={(value) =>
                                            updateTeamParticipant(
                                              team.id,
                                              index,
                                              value
                                            )
                                          }
                                        />
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              checked={participant.is_absent}
                                              style={{ color: "red" }}
                                              size="large"
                                              onChange={(e) => {
                                                updateTeamParticipantAbsent(
                                                  team.id,
                                                  index,
                                                  e.target.checked
                                                );
                                              }}
                                            />
                                          }
                                          label="Is Absent"
                                          labelPlacement="end"
                                        />
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </Grid>
                    ))}

                    {/* Add Extra Team Button */}
                    <Grid item xs={12}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          width: "100%",
                          marginTop: "20px",
                          marginBottom: "20px",
                        }}
                      >
                        <ReusableButton
                          text="Add Extra Team"
                          bgColor="#28a745"
                          fontSize={16}
                          height={50}
                          width={200}
                          iconType="add"
                          onClick={addExtraTeam}
                        />
                      </div>
                    </Grid>

                    {/* Save Button */}
                    <Grid item xs={12}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          width: "100%",
                          marginTop: "20px",
                        }}
                      >
                        <ReusableButton
                          text="Save All Team Members"
                          bgColor="#144A94"
                          fontSize={16}
                          height={50}
                          width={230}
                          onClick={() => handleSaveTeamMembers(teams)}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              ),
            },
            {
              label: "Upload Csv File",
              key: "UploadCsvFile",
              children: (
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems={"start"}
                  style={{ padding: 32 }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 20,
                    }}
                  >
                    <NunitoText
                      value="Only Upload CSV or XLSX File"
                      fontSize={20}
                      fontWeight={600}
                      color="#144A94"
                      align="left"
                    />

                    <div>
                      <input
                        type="file"
                        accept=".csv, .xlsx"
                        onChange={handleTeamMembersCsvFileChange}
                      />
                    </div>
                    <ReusableButton
                      text="Submit File"
                      bgColor="#144A94"
                      fontSize={14}
                      height={44}
                      width={140}
                      iconType="save"
                      onClick={() => handleUploadTeamMembersCsv()}
                      disabled={!csvFile}
                    />
                    {/* <button
                      onClick={() =>
                        handleUploadFile(
                          "competition/team-based/2025-simoc/mw/upload-answers",
                          file
                        )
                      }
                    >
                      Upload
                    </button> */}
                  </div>

                  <div style={{ width: 700 }}>
                    <p>
                      please make sure to add the csv header column like the
                      following: Division, Team Number, Participant 1, Is
                      Absent, Participant 2, Is Absent, Participant 3, Is
                      Absent, Participant 4, Is Absent, Participant 5, Is Absent
                    </p>
                    <p>each team must have 4 or 5 participants</p>
                    <p>
                      each participant column must be followed by its
                      corresponding "Is Absent" column (use 0, 1, "true", or
                      "false"). Values of 1 or "true" mean the participant is
                      absent, while 0 or "false" mean the participant is
                      present.
                    </p>
                    <p>division must be one of the following: LP, UP, LS, US</p>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: 20,
                        justifyContent: "flex-end",
                      }}
                    >
                      <ReusableButton
                        text="Download Sample Csv"
                        fontSize={15}
                        bgColor={"#5E75C3"}
                        height={46}
                        marginRight={30}
                        onClick={downloadSampleCsvTemplate}
                        iconType="download"
                      />
                    </div>
                  </div>
                </Grid>
              ),
            },
          ]}
        />
      </Grid>
    </Box>
  );
}
